module.exports = __webpack_public_path__ + "img/multiplier_2_win.23ba3753.png";